import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[blockCopyPaste]'
})
export class BlockCopyPasteDirective {

    constructor(el: ElementRef, renderer: Renderer2) {
        var events = 'copy paste drop';
        events.split(' ').forEach(e =>
            renderer.listen(el.nativeElement, e, (event) => {
                event.preventDefault();
            })
        );
    }

}
